import { HttpResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BuscadorModel } from '../interfaces/buscador-model.interface';
import { VfiscalUseCase } from 'src/app/domain/usecases/validacion-fiscal/vfiscal.usecase';


@Component({
  selector: 'app-reporte-vfiscal',
  templateUrl: './reporte-vfiscal.component.html',
  styleUrls: ['./reporte-vfiscal.component.css']
})
export class ReporteVfiscalComponent {

  

  @Output() isErrorEvent = new EventEmitter<boolean>(false);
  isReporte: boolean = false;

  constructor(
    private vfiscalUseCase: VfiscalUseCase) { }

  reporte(): void {
    this.isErrorEvent.emit(false);
    this.isReporte = true;
    this.vfiscalUseCase.export()
      .subscribe({
        next: (response: HttpResponse<Blob>) => {
          this.isReporte = false;
          this.vfiscalUseCase.descargarReporte(response, 'validacionFiscal');
          this.vfiscalUseCase.openAlert('success', '', '¡Generamos tu reporte! Se descargó automáticamente un archivo .CSV', 5000);
        },
        error: () => {
          this.isErrorEvent.emit(true);
          this.isReporte = false;
        }
      });
  }
  

}
